export default __webpack_public_path__ + "static/media/edit.2b61e83f.svg";